import 'css-chunk:src/components/widgets/IntroModal/IntroModal.scss';export default {
  "IntroModal": "_IntroModal_1rhoa_1",
  "dialog": "_dialog_1rhoa_4",
  "hidden": "_hidden_1rhoa_10"
};